/*
  AP-BOGO-OFFER — client logic for sections/ap-bogo-offer.liquid.
  State: one fabric for the order, a size per dress, which free print, add-on on/off + which one.
  Price display mirrors the store's native "B1G1 Dress" BXGY discount: of the two BOGO dresses the
  cheaper is free; the add-on pays full price. The real discount is applied by Shopify in the cart.
  Cart add = ONE /cart/add.js call with all lines, through a fetch from a blank iframe so apps that
  patch window.fetch (Kaching) cannot intercept it — same approach as bundle-builder-tier-math.js.
*/
(function () {
  'use strict';

  var FABRICS = ['Milk Silk', 'Cotton'];

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  var cleanWin = null;
  function cleanFetch(path, opts) {
    try {
      if (!cleanWin || !cleanWin.fetch) {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.setAttribute('aria-hidden', 'true');
        f.src = 'about:blank';
        document.documentElement.appendChild(f);
        cleanWin = f.contentWindow;
      }
      return cleanWin.fetch(location.origin + path, opts);
    } catch (e) {
      return window.fetch(path, opts);
    }
  }

  function init(root) {
    if (root.__apBo) return;
    root.__apBo = true;
    var data;
    try { data = JSON.parse(root.querySelector('[data-ap-bo-data]').textContent); } catch (e) { return; }
    var $ = function (sel, el) { return (el || root).querySelector(sel); };
    var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
    var money = function (c) { return formatMoney(c, data.moneyFormat); };

    var fabrics = FABRICS.filter(function (f) { return data.main.variants.some(function (v) { return v.fabric === f; }); });
    if (!fabrics.length) fabrics = [null];

    var state = { fabric: fabrics[0], free: 0, addon: false, addonIdx: 0, size: '' };

    function productFor(key) {
      if (key === 'main') return data.main;
      if (key === 'free') return data.free[state.free];
      return data.addon[state.addonIdx];
    }
    function variantFor(p, size, fabric) {
      if (!p) return null;
      return p.variants.find(function (v) { return v.size === size && (fabric === null || v.fabric === fabric); }) || null;
    }
    // price shown before a size is chosen: any variant in the chosen fabric
    function refVariant(p) {
      return p && (p.variants.find(function (v) { return state.fabric === null || v.fabric === state.fabric; }) || p.variants[0]);
    }
    function lineVariant(key) {
      return state.size ? variantFor(productFor(key), state.size, state.fabric) : null;
    }

    /* ---------- gallery: main track + thumbnails ---------- */
    var track = $('[data-ap-bo-track]');
    var thumbs = $$('.ap-bo__tbtn');
    if (track && thumbs.length) {
      var slides = $$('.ap-bo__slide', track);
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
      var markThumb = function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', i === j ? 'true' : 'false'); });
        var active = thumbs[i];
        if (active && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
          active.parentElement.scrollTo({ left: active.offsetLeft - 16, behavior: 'smooth' });
        }
      };
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; markThumb(); });
      }, { passive: true });
      markThumb();
    }

    /* ---------- fabric ---------- */
    var fabricWrap = $('[data-ap-bo-fabrics]');
    var firstFabricPrice = (data.main.variants.find(function (v) { return v.fabric === fabrics[0]; }) || {}).price || 0;
    fabrics.forEach(function (f) {
      if (f === null) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ap-bo__fab';
      b.dataset.fabric = f;
      var ref = data.main.variants.find(function (v) { return v.fabric === f; });
      var diff = ref ? ref.price - firstFabricPrice : 0;
      b.textContent = f + (diff > 0 ? '  +' + money(diff).replace(/\.00$/, '') : '');
      b.addEventListener('click', function () { setFabric(f); });
      fabricWrap.appendChild(b);
    });
    if (fabrics[0] === null) fabricWrap.closest('.ap-bo__opt').hidden = true;

    function setFabric(f) {
      if (fabrics.indexOf(f) < 0) return;
      state.fabric = f;
      render();
      document.dispatchEvent(new CustomEvent('ap-bo:fabric-changed', { detail: { fabric: f } }));
    }
    document.addEventListener('ap-bo:set-fabric', function (e) {
      if (e.detail && e.detail.fabric) setFabric(e.detail.fabric);
    });

    /* ---------- one size for every dress (user 17/09: pick size once) ---------- */
    var sizeWrap = $('[data-ap-bo-sizes]');
    // AP 2026-10-06 petite pilot: Petite sizes are not part of the one-size-for-every-dress picker
    var sizeBtns = data.main.sizes.filter(function (s) { return !/^Petite\b/.test(s); }).map(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ap-bo__szbtn';
      b.setAttribute('role', 'radio');
      b.textContent = s;
      b.addEventListener('click', function () {
        state.size = s;
        sizeWrap.classList.remove('is-missing');
        showError('');
        render();
      });
      sizeWrap.appendChild(b);
      return { size: s, el: b };
    });
    // a size is pickable only when every dress currently in the order has it in the chosen fabric
    function sizeOk(s) {
      var keys = ['main', 'free'].concat(state.addon ? ['addon'] : []);
      return keys.every(function (k) {
        var v = variantFor(productFor(k), s, state.fabric);
        return v && v.available;
      });
    }
    function renderSizes() {
      if (state.size && !sizeOk(state.size)) state.size = '';
      sizeBtns.forEach(function (b) {
        var ok = sizeOk(b.size);
        b.el.disabled = !ok;
        b.el.setAttribute('aria-checked', b.size === state.size ? 'true' : 'false');
        b.el.title = ok ? '' : 'Sold out in this combination';
      });
      var name = $('[data-ap-bo-size-name]');
      if (name) name.textContent = state.size;
    }

    /* ---------- swatches (always open) ---------- */
    $$('[data-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var idx = Number(sw.dataset.index);
        if (sw.dataset.swatch === 'free') state.free = idx;
        else { state.addonIdx = idx; state.addon = true; }
        render();
      });
    });

    /* ---------- add-on ---------- */
    var addonToggle = $('[data-addon-toggle]');
    if (addonToggle) {
      addonToggle.addEventListener('change', function () {
        state.addon = addonToggle.checked;
        render();
      });
    }

    /* ---------- size chart dialog (moved to <body> so no ancestor can clip it) ---------- */
    var sc = $('[data-ap-bo-sc]');
    if (sc) {
      document.body.appendChild(sc);
      var tabs = Array.prototype.slice.call(sc.querySelectorAll('[data-sc-tab]'));
      var panels = Array.prototype.slice.call(sc.querySelectorAll('[data-sc-panel]'));
      var showTab = function (i) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      };
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { showTab(i); }); });
      sc.addEventListener('click', function (e) {
        if (e.target === sc || e.target.closest('[data-close]')) sc.close();
      });
      $$('[data-ap-bo-sc-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (typeof sc.showModal === 'function') sc.showModal(); else sc.setAttribute('open', '');
        });
      });
    }

    /* ---------- "View details": big look at one print, browse the others, choose it ---------- */
    var pd = $('[data-ap-bo-pd]');
    var pdState = { key: 'free', idx: 0, img: 0 };
    if (pd) {
      document.body.appendChild(pd);
      var pq = function (sel) { return pd.querySelector(sel); };
      var listFor = function (k) { return k === 'free' ? data.free : data.addon; };
      var renderPd = function () {
        var list = listFor(pdState.key);
        var p = list[pdState.idx];
        if (!p) return;
        var gallery = p.gallery && p.gallery.length ? p.gallery : [p.image];
        pdState.img = Math.min(pdState.img, gallery.length - 1);
        var img = pq('[data-pd-img]');
        img.src = gallery[pdState.img];
        img.alt = p.title;
        var thumbs = pq('[data-pd-thumbs]');
        thumbs.innerHTML = '';
        gallery.forEach(function (src, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ap-bo__pdthumb';
          b.setAttribute('aria-label', 'Photo ' + (i + 1));
          b.setAttribute('aria-current', i === pdState.img ? 'true' : 'false');
          var im = document.createElement('img');
          im.src = src.replace('width=900', 'width=200');
          im.alt = '';
          b.appendChild(im);
          b.addEventListener('click', function () { pdState.img = i; renderPd(); });
          thumbs.appendChild(b);
        });
        var v = refVariant(p);
        var price = v ? v.price : 0;
        var compare = v ? Math.max(v.compare, v.price) : 0;
        var free = pdState.key === 'free';
        pq('[data-pd-eyebrow]').textContent = free
          ? 'FREE WITH ' + data.main.name.toUpperCase() + ' · BUY 1 GET 1'
          : 'OUR ALL-TIME BEST-SELLER · +' + money(price) + (compare > price ? ' (usually ' + money(compare) + ')' : '');
        pq('[data-pd-title]').textContent = p.title;
        pq('[data-pd-count]').textContent = (pdState.idx + 1) + ' of ' + list.length + ' prints';
        pd.querySelectorAll('[data-pd-details]').forEach(function (ul) { ul.hidden = ul.dataset.pdDetails !== pdState.key; });
        var current = free ? state.free : (state.addon ? state.addonIdx : -1);
        pq('[data-pd-choose]').textContent = pdState.idx === current
          ? 'SELECTED ✓'
          : (free ? 'CHOOSE ' + p.name.toUpperCase() + ' — FREE' : 'ADD ' + p.name.toUpperCase() + ' — +' + money(price));
      };
      pd.addEventListener('click', function (e) {
        if (e.target === pd || e.target.closest('[data-close]')) { pd.close(); return; }
        var step = e.target.closest('[data-pd-step]');
        if (step) {
          var n = listFor(pdState.key).length;
          pdState.idx = (pdState.idx + Number(step.dataset.pdStep) + n) % n;
          pdState.img = 0;
          renderPd();
          return;
        }
        if (e.target.closest('[data-pd-choose]')) {
          if (pdState.key === 'free') state.free = pdState.idx;
          else { state.addonIdx = pdState.idx; state.addon = true; }
          render();
          pd.close();
        }
      });
      $$('[data-view]').forEach(function (b) {
        b.addEventListener('click', function () {
          pdState.key = b.dataset.view;
          pdState.idx = pdState.key === 'free' ? state.free : state.addonIdx;
          pdState.img = 0;
          renderPd();
          if (typeof pd.showModal === 'function') pd.showModal(); else pd.setAttribute('open', '');
        });
      });
    }

    /* ---------- render ---------- */
    function paintRow(key) {
      var row = $('[data-row="' + key + '"]');
      var p = productFor(key);
      if (!row || !p) return;
      var img = $('[data-thumb]', row);
      if (img && img.getAttribute('src') !== p.image) img.setAttribute('src', p.image);
      $$('[data-name]', row).forEach(function (n) { n.textContent = p.name; });
    }

    function totals() {
      var dress = ['main', 'free'].map(function (k) { return lineVariant(k) || refVariant(productFor(k)); });
      var prices = dress.map(function (v) { return v ? v.price : 0; });
      var compare = dress.reduce(function (s, v) { return s + (v ? Math.max(v.compare, v.price) : 0); }, 0);
      var total = prices[0] + prices[1] - Math.min(prices[0], prices[1]);
      var t = { total: total, compare: compare, count: 2, addonPrice: 0, addonCompare: 0 };
      if (data.addon.length) {
        var av = lineVariant('addon') || refVariant(productFor('addon'));
        t.addonPrice = av ? av.price : 0;
        t.addonCompare = av ? Math.max(av.compare, av.price) : 0;
        if (state.addon) {
          t.total += t.addonPrice;
          t.compare += t.addonCompare;
          t.count = 3;
        }
      }
      return t;
    }

    function render() {
      renderSizes();
      ['main', 'free', 'addon'].forEach(paintRow);

      $$('.ap-bo__fab', fabricWrap).forEach(function (b) {
        var on = b.dataset.fabric === state.fabric;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var fabName = $('[data-ap-bo-fabric-name]');
      if (fabName) fabName.textContent = state.fabric || '';

      $$('[data-swatch]').forEach(function (sw) {
        // the add-on keeps its current pick highlighted even when unticked (dimmed by CSS) so the label and swatch agree
        var current = sw.dataset.swatch === 'free' ? state.free : state.addonIdx;
        sw.setAttribute('aria-checked', Number(sw.dataset.index) === current ? 'true' : 'false');
      });
      $$('[data-pick-name="free"]').forEach(function (n) { n.textContent = productFor('free') ? productFor('free').name : ''; });
      $$('[data-pick-name="addon"]').forEach(function (n) { n.textContent = productFor('addon') ? productFor('addon').name : ''; });

      var addonRow = $('[data-row="addon"]');
      if (addonRow) {
        addonRow.classList.toggle('is-on', state.addon);
        addonToggle.checked = state.addon;
      }

      var t = totals();
      $('[data-ap-bo-total]').textContent = money(t.total);
      $('[data-ap-bo-was]').textContent = t.compare > t.total ? money(t.compare) : '';
      var ap = $('[data-addon-price]');
      if (ap) ap.textContent = '+' + money(t.addonPrice);
      // add-on value: "usually" = the regular store price carried as the clone's compare-at
      var aw = $('[data-addon-was]');
      if (aw) aw.textContent = t.addonCompare > t.addonPrice ? money(t.addonCompare) : '';
      var asv = $('[data-addon-save]');
      if (asv) asv.textContent = t.addonCompare > t.addonPrice ? 'Save ' + money(t.addonCompare - t.addonPrice).replace(/\.00$/, '') : '';
      $('[data-ap-bo-atc]').textContent = 'ADD ' + t.count + ' DRESSES · ' + money(t.total);
    }

    /* ---------- add to cart ---------- */
    var atc = $('[data-ap-bo-atc]');
    var err = $('[data-ap-bo-error]');
    function showError(msg) { err.textContent = msg; err.hidden = !msg; }

    atc.addEventListener('click', function () {
      var keys = ['main', 'free'].concat(state.addon ? ['addon'] : []);
      if (!state.size) {
        sizeWrap.classList.add('is-missing');
        sizeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        showError('Pick your size first.');
        return;
      }
      var items = keys.map(function (k) {
        var v = lineVariant(k);
        return v ? { id: v.id, quantity: 1, properties: { _offer: 'bogo-offer' } } : null;
      });
      if (items.some(function (i) { return !i; })) { showError('That size is not available in this fabric.'); return; }
      showError('');
      atc.disabled = true;
      var label = atc.textContent;
      atc.textContent = 'ADDING…';
      cleanFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items }),
      }).then(function (r) {
        return r.text().then(function (txt) {
          var j = null;
          try { j = JSON.parse(txt); } catch (e) { /* bot-check HTML */ }
          if (r.ok && j) return j;
          throw { status: r.status, json: j };
        });
      }).then(function () {
        window.location.href = data.cartUrl || '/cart';
      }).catch(function (e) {
        atc.disabled = false;
        atc.textContent = label;
        var msg = e && e.json && e.json.description;
        showError(msg || 'Something stopped your dresses reaching the cart. Tap once more.');
      });
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-ap-bo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
